function $5acd4814b1dd22fa$export$69d5a0bee28624af(r, g, b) {
    r /= 255;
    g /= 255;
    b /= 255;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    let h = 0;
    let s = 0;
    let l = (max + min) / 2;
    if (max === min) {
        h = 0;
        s = 0;
    } else {
        const span = max - min;
        s = l > 0.5 ? span / (2 - max - min) : span / (max + min);
        switch(max){
            case r:
                h = (g - b) / span + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / span + 2;
                break;
            case b:
                h = (r - g) / span + 4;
                break;
        }
        h /= 6;
    }
    return [
        h,
        s,
        l
    ];
}
function $5acd4814b1dd22fa$export$b973f735a0b1be26(h, s, l) {
    function rgb_from_hue(p, q, t) {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 0.5) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
    }
    let r = 0;
    let g = 0;
    let b = 0;
    if (s === 0) {
        r = l;
        g = l;
        b = l;
    } else {
        const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        const p = 2 * l - q;
        r = rgb_from_hue(p, q, h + 1 / 3);
        g = rgb_from_hue(p, q, h);
        b = rgb_from_hue(p, q, h - 1 / 3);
    }
    return [
        Math.max(Math.min(r * 256, 255), 0),
        Math.max(Math.min(g * 256, 255), 0),
        Math.max(Math.min(b * 256, 255), 0)
    ];
}


function $22df7d588c6ad6ef$var$clone(value) {
    return JSON.parse(JSON.stringify(value));
}
function $22df7d588c6ad6ef$export$1010be256a6932bb(samples, cluster_count, initial_guess, distance) {
    const cluster_means = $22df7d588c6ad6ef$var$clone(initial_guess);
    let cluster_of_sample = new Array(samples.length).fill(-1);
    let cluster_size = new Array(cluster_count).fill(0);
    let clusters_changed = true;
    while(clusters_changed){
        cluster_size.fill(0);
        clusters_changed = false;
        // Associate each sample with its nearest cluster mean.
        samples.forEach((sample, sample_index)=>{
            let nearest_cluster_mean_index = 0;
            let nearest_cluster_mean_distance = distance(sample, cluster_means[0]);
            for(let i = 1; i < cluster_count; ++i){
                const distance_to_cluster_mean_i = distance(sample, cluster_means[i]);
                if (distance_to_cluster_mean_i < nearest_cluster_mean_distance) {
                    nearest_cluster_mean_distance = distance_to_cluster_mean_i;
                    nearest_cluster_mean_index = i;
                }
            }
            if (cluster_of_sample[sample_index] === -1 || cluster_of_sample[sample_index] !== nearest_cluster_mean_index) clusters_changed = true;
            cluster_of_sample[sample_index] = nearest_cluster_mean_index;
            cluster_size[nearest_cluster_mean_index] += 1;
        });
        // Recompute the means.
        if (clusters_changed) {
            cluster_means.forEach((mean)=>mean.fill(0));
            samples.forEach((sample, sample_index)=>{
                const sample_cluster_index = cluster_of_sample[sample_index];
                const sample_cluster_size = cluster_size[sample_cluster_index];
                const cluster_mean = cluster_means[sample_cluster_index];
                cluster_mean.forEach((_, i)=>cluster_mean[i] += sample[i] / sample_cluster_size);
            });
        }
    }
    return cluster_means.map((mean, index)=>{
        return {
            mean: mean,
            size: cluster_size[index]
        };
    }).filter((cluster)=>cluster.size > 0);
}


function $64cc8ecea770fe07$var$random_integer_in_range(min, max) {
    return min + Math.floor(Math.random() * (max - min + 1));
}
function $64cc8ecea770fe07$export$85a4233b636598d(image_data, sampling_cell_size, palette_size) {
    // Collect color observations using jittered-grid super sampling.
    const samples_rgb = [];
    for(let x_min = 0; x_min < image_data.width - sampling_cell_size; x_min += sampling_cell_size)for(let y_min = 0; y_min < image_data.height - sampling_cell_size; y_min += sampling_cell_size){
        const x = $64cc8ecea770fe07$var$random_integer_in_range(x_min, x_min + sampling_cell_size);
        const y = $64cc8ecea770fe07$var$random_integer_in_range(y_min, y_min + sampling_cell_size);
        const sample_index = 4 * (x + y * image_data.width);
        const sample_slice = image_data.data.slice(sample_index, sample_index + 3);
        samples_rgb.push([
            sample_slice[0],
            sample_slice[1],
            sample_slice[2]
        ]);
    }
    const samples_hsl = samples_rgb.map((color)=>(0, $5acd4814b1dd22fa$export$69d5a0bee28624af)(color[0], color[1], color[2]));
    const clusters_initial_guess = [];
    for(let i = 0; i < palette_size; i += 1){
        const random_index = $64cc8ecea770fe07$var$random_integer_in_range(0, samples_hsl.length - 1);
        clusters_initial_guess.push(samples_hsl[random_index]);
    }
    function hsl_distance(a, b) {
        return (a[0] - b[0]) * (a[0] - b[0]) + (a[1] - b[1]) * (a[1] - b[1]) + (a[2] - b[2]) * (a[2] - b[2]);
    }
    return (0, $22df7d588c6ad6ef$export$1010be256a6932bb)(samples_hsl, palette_size, clusters_initial_guess, hsl_distance).sort((a, b)=>b.size - a.size).map((cluster)=>(0, $5acd4814b1dd22fa$export$b973f735a0b1be26)(cluster.mean[0], cluster.mean[1], cluster.mean[2]));
}
function $64cc8ecea770fe07$export$1059ec8f4511ea27(image, sampling_cell_size, palette_size) {
    const canvas = document.createElement("canvas");
    canvas.width = image.naturalWidth;
    canvas.height = image.naturalHeight;
    const context = canvas.getContext("2d");
    if (context === null) throw new Error("cannot get canvas context");
    context.drawImage(image, 0, 0, canvas.width, canvas.height);
    const image_data = context.getImageData(0, 0, canvas.width, canvas.height);
    return $64cc8ecea770fe07$export$85a4233b636598d(image_data, sampling_cell_size, palette_size);
}


function $890a7e4059f9b56c$var$on_selected_image_change(file_input) {
    if (file_input.files === null || file_input.files.length !== 1) return;
    const file = file_input.files.item(0);
    if (file === null) return;
    const image = new Image();
    image.src = URL.createObjectURL(file);
    image.addEventListener("load", ()=>{
        const color_elements = document.querySelectorAll(".demo-palette-color");
        const palette_size = color_elements.length;
        const sampling_cell_size = Math.ceil(Math.min(image.naturalWidth, image.naturalHeight) / 20);
        const palette = (0, $64cc8ecea770fe07$export$1059ec8f4511ea27)(image, sampling_cell_size, palette_size).map((color)=>color.map(Math.round));
        for(let i = 0; i < color_elements.length; i += 1)color_elements.item(i).style.removeProperty("background-color");
        for(let i = 0; i < palette.length; i += 1){
            const color = palette[i];
            const element = color_elements.item(i);
            element.style.backgroundColor = `rgb(${color[0]}, ${color[1]}, ${color[2]})`;
            element.setAttribute("aria-label", `Colored square: rgb(${color[0]}, ${color[1]}, ${color[2]})`);
        }
    });
}
function $890a7e4059f9b56c$var$setup() {
    const file_input = document.getElementById("demo-image");
    if (!(file_input instanceof HTMLInputElement)) return;
    file_input.addEventListener("change", ()=>$890a7e4059f9b56c$var$on_selected_image_change(file_input));
    document.getElementById("demo-select-image-button")?.addEventListener("click", ()=>file_input.click());
}
window.addEventListener("DOMContentLoaded", $890a7e4059f9b56c$var$setup);


//# sourceMappingURL=index.cb802b4f.js.map
